import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import { TTLogo } from "@airborne/react-admin";

const useStyles = makeStyles(theme => ({
  root: {
    // padding: '2px 4px',
    display: "flex",
    alignItems: "center",
    width: 390,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function SearchMenuInput(props) {
  const classes = useStyles();
  const { reset, ...useOptions } = useField(props.onChange);
  return (
    <div className={classes.root}>
      <InputBase
        {...useOptions}
        className={classes.input}
        placeholder="Search Pages"
        inputProps={{ "aria-label": "search pages " }}
      />
      <IconButton type="submit" className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
      <Divider className={classes.divider} orientation="vertical" />
      <IconButton
        color="primary"
        className={classes.iconButton}
        aria-label="directions"
        style={{ width: 200, height: 40 }}
      >
        <TTLogo />
      </IconButton>
    </div>
  );
}
export const useField = tempOnChange => {
  const [value, setValue] = useState("");
  const [timeoutId, setTimeoutId] = React.useState<NodeJS.Timeout>();
  const onChange = event => {
    setValue(event.target.value);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    // tempOnChange(event.target.value)
    const tempTimeoutId = setTimeout(() => {
      tempOnChange(event.target.value);
      setTimeoutId(undefined);
    }, 500);
    setTimeoutId(tempTimeoutId);
  };
  const reset = () => {
    setValue("");
  };

  return {
    value,
    onChange,
    reset,
  };
};
